import styles from './index.module.sass';
import schiberSvg from './schiber.svg';

export const SchiberBadge = ({ mirroring, multi = false }: ISchiberBadge) => {
  return (
    <div className={styles.badgeBody}>
      <img
        className={mirroring && styles.mirrored}
        src={schiberSvg}
        alt="illustration"
      />
      <span>
        {!multi
          ? 'необходимо настроить шиберные заслонки таким образом, чтобы объем зерна в первом бункере закончился одновременно с объемом зерна во втором бункере'
          : 'необходимо настроить шиберные заслонки таким образом, чтобы объемы зерна в секциях, закончились одновременно'}
      </span>
    </div>
  );
};

interface ISchiberBadge {
  mirroring?: boolean;
  multi: boolean;
}
